<template>
	<v-dialog v-model="dialog" width="1200" persistent>
		<v-card>
			<v-card-title class="primary py-3 pr-5 fixedTop white--text">
				<span class="title">Customer Existing Services</span>
				<v-btn
					absolute
					top
					right
					fab
					dark
					text
					icon
					small
					style="margin: 27px 0 0 0 !important"
					@click="
            $emit('close');
          "
				>
					<v-icon color="white--text">clear</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<v-flex offset-xs8>
					<v-text-field
						solo
						prepend-inner-icon="search"
						clearable
						v-model="search"
						label="Search"
						hide-details
					></v-text-field>
				</v-flex>

				<v-data-table
					v-model="selected"
					:headers="headers"
					:items="items"
					:search="search"
					item-key="service"
					class="elevation-1 mt-3"
					show-select
				></v-data-table>
			</v-card-text>

			<v-card-actions class="pa-3">
				<v-spacer></v-spacer>

				<v-btn
					text
					@click="$emit('calculate', selected); $emit('close')"
					:disabled="selected.length == 0"
					class="primary"
				>{{ buttonText }}</v-btn>
				<v-btn text @click="
            $emit('close')
          ">Cancel</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
	name: "ExistingServices",
	props: {
		dialog: { type: Boolean }
	},
	data () {
		return {
			account: null,
			headers: [
				{ text: "Service", value: "service" },
				{ text: "Start Date", value: "added", sortable: false },
				{ text: "Released Date", value: "released", sortable: false },
				{ text: "Rate Plan", value: "plan", sortable: false }
			],
			items: [],
			voip: [],
			totalItems: 0,
			search: "",
			disable: true,
			selected: [],
			showAll: false,
			selectAllDisable: false,
			buttonText: "Calculate credit for selected item",
			accountClone: null
		};
	},
	methods: {
		...mapActions("reminders", ["setMessage", "getServices"]),
		loadServices (account) {

			if (account == '') {
				this.items = [];
				this.selected = [];
				return;
			}

			//Clear selected IF account is changed
			if (this.selected.length > 0) {

				if (this.account && this.account !== account)
					this.selected = [];

			}


			this.account = account;

			this.getServices(this.account).then(data => {
				if (data.some(x => x.type.toUpperCase() == "VOIP")) {
					this.setMessage({ message: "Data loaded!", httpStatus: 200 });
				} else {
					this.setMessage({
						message: "VoIP data not available!",
						httpStatus: 500
					});
				}
				this.items = data;

				if (
					!this.items.some(
						x =>
							x.type === "VoIP" &&
							!x.plan.toLowerCase().includes("fax") &&
							!x.released
					)
				) {
					this.selectAllDisable = true;
				}
			});

		},
		resetServices () {
			this.items = [];
			this.selected = [];
			this.account = null;
			this.accountClone = null;
		}
	},
	filters: {
		formatDate: function (date) {
			if (!date) return null;

			const [year, month, day] = date.substring(0, 10).split("-");
			return `${day}/${month}/${year}`;
		}
	}
};
</script>

<style>
.fixedTop {
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	z-index: 999;
}
</style>
